// Site meta/SEO API (backend/src/game/meta). Public GET /meta feeds the
// storefront <head> (utils/meta.ts); /admin/meta is the admin editor.
import { api } from './client';
import { fileForm, MULTIPART } from './uploads';

export interface IconLink {
  rel: string;
  sizes: string;
  type?: string;
  href: string;
}

/** Empty strings mean "no override — keep the storefront default". */
export interface SiteMeta {
  title: string;
  description: string;
  siteName: string;
  image: string;
  imageAlt: string;
  imageWidth: string;
  imageHeight: string;
  twitterCard: string;
  /** Uploaded icons only; empty keeps the icons index.html ships. */
  icons: IconLink[];
}

/** Icon slot keys, matching backend ICON_SLOTS. */
export type MetaIconSlot = 'icon_ico' | 'icon_png_16' | 'icon_png_32' | 'icon_png_180';
/** Keys an admin edits as text. */
export type MetaTextKey = 'title' | 'description' | 'site_name' | 'image' | 'image_alt' | 'twitter_card';
/** Raw stored values as GET /admin/meta returns them. */
export type MetaValues = Record<MetaTextKey | MetaIconSlot | 'image_width' | 'image_height', string>;

export const fetchSiteMeta = () => api.get<SiteMeta>('/meta').then((r) => r.data);

export const fetchMetaValues = () => api.get<MetaValues>('/admin/meta').then((r) => r.data);
export const updateMetaValues = (settings: Partial<Record<MetaTextKey, string>>) =>
  api.post<MetaValues>('/admin/meta', { settings }).then((r) => r.data);

export const uploadMetaImage = (file: File) => api.post('/admin/meta/image', fileForm(file), MULTIPART);
export const removeMetaImage = () => api.delete('/admin/meta/image');
export const uploadMetaIcon = (slot: MetaIconSlot, file: File) => api.post(`/admin/meta/icons/${slot}`, fileForm(file), MULTIPART);
export const removeMetaIcon = (slot: MetaIconSlot) => api.delete(`/admin/meta/icons/${slot}`);
